module.exports = __webpack_public_path__ + "img/5even.9495ad6e.jpg";